import React from "react";
import UserProfileCard from "../UserProfileCard";

function UserProfile() {
  return (
    <section className="w-100 z-0">
      <div>
        <h1 className="text-3xl font-semibold sm:text-5xl">MOCHI #36</h1>
        <a
          href="#"
          className="inline-flex gap-2 text-[#666666] hover:text-[#000] font-semibold mt-4"
        >
          Minted on Jan 1, 2022
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>
      </div>

      <div className="grid md:grid-cols-2 my-8 gap-x-12 gap-y-4">
        {/* Left Side Section */}
        <div>
          <div className="sm:inline-grid md:grid-cols-2 gap-4">
            <div className="">
              <p className="font-semibold text-[#666666]">Created by</p>
              <div className="bg-[#fff] text-[#000] px-4 py-3 my-4 shadow-lg hover:shadow-xl inline-flex justify-between cursor-pointer gap-3 items-center rounded-full uppercase font-semibold hover:-translate-y-0.5 duration-300 ease-out group relative">
                <div className="w-8 h-8 rounded-full truncate">
                  <img src="assets/images/user/user.jpg" alt="User Image" />
                </div>
                <a>@stillz</a>
                <UserProfileCard />
              </div>
            </div>

            <div className="md:even:border-l border-[#f2f2f2] md:pl-8">
              <p className="font-semibold text-[#666666]">Collection</p>
              <div className="bg-[#fff] text-[#000] px-4 py-3 my-4 shadow-lg hover:shadow-xl inline-flex justify-between cursor-pointer gap-3 items-center rounded-lg uppercase font-semibold hover:-translate-y-0.5 duration-300 ease-out group relative">
                <div className="w-8 h-8 rounded-full truncate">
                  <img src="assets/images/user/user.jpg" alt="User Image" />
                </div>
                <a>mochi</a>
                <UserProfileCard />
              </div>
            </div>
          </div>
        </div>

        {/* Right Side Section */}
        <div className="md:border-l md:pl-16">
          <div className="inline-grid lg:grid-cols-2 gap-4">
            <div>
              <p className="font-semibold text-[#666666]">Sold for</p>
              <h2 className="uppercase font-semibold text-2xl md:text-4xl">
                2.00 eth
              </h2>
              <p className="font-semibold text-[#666666]">$5,718.24</p>
            </div>

            <div>
              <p className="font-semibold text-[#666666]">Collection</p>
              <div className="bg-[#fff] text-[#000] px-4 py-3 my-4 shadow-lg hover:shadow-xl inline-flex justify-between cursor-pointer gap-3 items-center rounded-full font-semibold hover:-translate-y-0.5 duration-300 ease-out relative group">
                <div className="w-8 h-8 rounded-full truncate">
                  <img src="assets/images/user/user.jpg" alt="User Image" />
                </div>
                <a>@weownthecity</a>
                <UserProfileCard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default UserProfile;
